module.exports = __webpack_public_path__ + "static/img/smt_offiaccount.e23418bf.png";